import { Checkbox } from "../ui/checkbox";

// Per-question show/hide of block categories and individual blocks (Junior + Blocks modes).
// `lockedCategories` can't be hidden entirely (e.g. Junior "Drill" moves, Blocks "Program" output).
export const BlockRulesEditor = ({ categories, excludedCategories = [], excludedBlocks = [], onChange, lockedCategories = [], testId = "block-rules-editor", hint }) => {
  const exCats = new Set(excludedCategories);
  const exBlocks = new Set(excludedBlocks);
  const locked = new Set(lockedCategories);

  const toggleCat = (id) => {
    const next = new Set(exCats);
    next.has(id) ? next.delete(id) : next.add(id);
    onChange({ excluded_categories: [...next], excluded_blocks: [...exBlocks] });
  };
  const toggleBlock = (type) => {
    const next = new Set(exBlocks);
    next.has(type) ? next.delete(type) : next.add(type);
    onChange({ excluded_categories: [...exCats], excluded_blocks: [...next] });
  };
  const showAll = () => onChange({ excluded_categories: [], excluded_blocks: [] });

  const hiddenCount = categories.reduce((n, c) => n + (exCats.has(c.id) ? c.blocks.length : c.blocks.filter((b) => exBlocks.has(b.type)).length), 0);

  return (
    <div data-testid={testId}>
      <div className="flex items-center justify-between gap-2 mb-1 flex-wrap">
        <p className="text-sm font-medium">Blocks available to the student <span className="text-muted-foreground font-normal">(untick to hide)</span></p>
        <span className="text-xs text-muted-foreground flex items-center gap-2">
          <span data-testid={`${testId}-hidden-count`}>{hiddenCount ? `${hiddenCount} hidden` : "All shown"}</span>
          {hiddenCount > 0 && <button type="button" className="text-primary hover:underline" onClick={showAll} data-testid={`${testId}-show-all`}>Show all</button>}
        </span>
      </div>
      {hint && <p className="text-xs text-muted-foreground mb-2">{hint}</p>}
      <div className="grid sm:grid-cols-3 gap-3">
        {categories.map((cat) => {
          const catOff = exCats.has(cat.id);
          return (
            <div key={cat.id} className={`rounded-lg border border-border p-3 space-y-2 ${catOff ? "opacity-60" : ""}`} data-testid={`${testId}-cat-${cat.id}`}>
              <label className="flex items-center gap-2 text-sm font-semibold cursor-pointer">
                <Checkbox checked={!catOff} onCheckedChange={() => toggleCat(cat.id)} disabled={locked.has(cat.id)} data-testid={`${testId}-cat-toggle-${cat.id}`} />
                {cat.name}
              </label>
              <div className="pl-6 space-y-1.5">
                {cat.blocks.map((b) => (
                  <label key={b.type} className="flex items-center gap-2 text-xs cursor-pointer">
                    <Checkbox checked={!catOff && !exBlocks.has(b.type)} disabled={catOff} onCheckedChange={() => toggleBlock(b.type)} data-testid={`${testId}-block-${b.type}`} />
                    {b.label}
                  </label>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
